import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'

// PrimeVue 4.x is pinned (ADR-011 / D14): 5.x changed the licence.
// Brand palette from packages/shared/tokens.css: the logo's pink (#e8457a) at 400, the readable
// action pink (#cc3366, 5:1 on white) at 500 where PrimeVue draws its buttons.
export const RozaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fff4f7',
      100: '#ffe3ec',
      200: '#ffc6d8',
      300: '#f6a5c0',
      400: '#e8457a',
      500: '#cc3366',
      600: '#b8295a',
      700: '#a3234f',
      800: '#8a1d43',
      900: '#6e1736',
      950: '#3d0e22',
    },
  },
})
